// @flow
import { createActions, handleActions } from 'redux-actions'

export type CategorySelectionState = {
  flatSize: string,
  priceRange: string
}

export type CategorySelectionActions = {
  type: 'SELECTOR/FLATSIZE/SET' | 'SELECTOR/PRICERANGE/SET',
  payload: string
}

export const selectorActions = createActions({
  SELECTOR: {
    FLATSIZE: {
      SET: undefined
    },
    PRICERANGE: {
      SET: undefined
    }
  }
})

export const categorySelection: (
  state: CategorySelectionState,
  action: CategorySelectionActions
) => CategorySelectionState = handleActions(
  {
    'SELECTOR/FLATSIZE/SET': (state, { payload }) => ({
      ...state,
      flatSize: payload
    }),
    'SELECTOR/PRICERANGE/SET': (state, { payload }) => ({
      ...state,
      priceRange: payload
    })
  },
  {
    flatSize: '3',
    priceRange: '3'
  }
)

export default categorySelection
